import { useMemo, useRef } from 'react'

import { ClientListClientObject } from '@lyrahealth-inc/shared-app-logic/src/models/client/ClientListClient'

import { useAllClientsData } from '../../../lyraTherapy/clients/data/hooks/useAllClientsData'

export const useWithClient = <T>(
  rawItems: T[] | undefined,
  getPatientId: (item: T) => string | null | undefined,
): {
  items: (T & { client: ClientListClientObject })[]
  isLoading: boolean
  isFetching: boolean
  isSuccess: boolean
} => {
  const [clients, activeClientsQuery, inactiveClientsQuery] = useAllClientsData()

  const clientsById = useMemo(() => new Map(clients.map((c) => [c.id, c])), [clients])

  const getPatientIdRef = useRef(getPatientId)
  getPatientIdRef.current = getPatientId

  const items = useMemo(() => {
    if (!rawItems) {
      return []
    }
    return rawItems
      .filter((item) => {
        const id = getPatientIdRef.current(item)
        return id && clientsById.has(id)
      })
      .map((item) => ({
        ...item,
        client: clientsById.get(getPatientIdRef.current(item)!)!,
      }))
  }, [rawItems, clientsById])

  return {
    items,
    isLoading: activeClientsQuery.isLoading || inactiveClientsQuery.isLoading,
    isFetching: activeClientsQuery.isFetching || inactiveClientsQuery.isFetching,
    isSuccess: activeClientsQuery.isSuccess && inactiveClientsQuery.isSuccess,
  }
}
